<template>
    <div>
        <div>
            <tab-bar @on-pdf="handlerDownPdf"
                     @on-set="handlerToggleSet"
                     ref="tabBar"
                     :set="set"
                     :cs="rangeList.list"
                     :img="img"
                     :rt="rtable"/>
            <div class="wrapper-padding" v-show="!setShow">
                <div class="main-body">
                    <div class="left-chart">
                        <echarts :zcb="jjfazcbMoney" :zsy="ntzhbMoney"/>
                    </div>
                    <div class="right-table" ref="rightTable">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>分类</th>
                                <th>项目</th>
                                <th>数值</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="bold" rowspan="2">时间成本</td>
                                <td>每年培训总时长节约（小时）</td>
                                <td v-active><span>{{mnpxscTime}}</span></td>
                            </tr>
                            <tr>
                                <td>时间成本节约（元/年）</td>
                                <td v-active><span>{{sjcbjyMoney}}</span></td>
                            </tr>
                            <tr>
                                <td class="bold" rowspan="2">工件损坏成本</td>
                                <td>每年减少工件损坏数量</td>
                                <td v-active><span>{{jsgjshNumber}}</span></td>
                            </tr>
                            <tr>
                                <td>工件损坏成本节约（元/年）</td>
                                <td v-active><span>{{gjshcbMoney}}</span></td>
                            </tr>
                            <tr>
                                <td class="bold" rowspan="2">人员重复培训成本</td>
                                <td>每年减少重复培训次数</td>
                                <td v-active><span>{{jccfpxNumber}}</span></td>
                            </tr>
                            <tr>
                                <td>重复培训成本节约（元/年）</td>
                                <td v-active><span>{{cfpxcbMoney}}</span></td>
                            </tr>
                            <tr>
                                <td class="bold">SQS产品成本</td>
                                <td>SQS解决方案总成本（元）</td>
                                <td v-active><span>{{jjfazcbMoney}}</span></td>
                            </tr>
                            </tbody>
                        </table>
                        <ul class="bottom-list">
                            <li>年投资回报（元）{{ntzhbMoney}}</li>
                            <li class="yellow">投资回报周期（月）{{tzhbzqTime}}</li>
                            <li>平均投资回报（元/次）{{pjtzhbMoney}}</li>
                        </ul>
                    </div>
                </div>
                <div class="operate-wrapper">
                    <span class="label">{{rangeList.list[rangeList.active].label}}</span>
                    <div class="range">
                        <input v-model="range" v-range type="range">
                    </div>
                    <div class="inp">
                        <input type="number" v-model="range" class="input">
                    </div>
                </div>
                <!--{{rangeList.list}}-->
                <ul class="select-wrapper">
                    <li :class="{active: rangeList.active === key}"
                        v-for="(item, key) in rangeList.list"
                        @click="handlerTab(item, key)"
                        :key="key">
                        <i class="iconfont" :class="item.icon"></i>
                        <div>{{ item.name }}</div>
                    </li>
                </ul>
            </div>
            <set-form :set-value="set" v-model="setShow" @on-ok="handlerOk"/>
        </div>
        <div class="none-echart">
            <echarts ref="Charts" :zcb="jjfazcbMoney" :zsy="ntzhbMoney"/>
        </div>
    </div>
</template>

<script>
    import TabBar from '../../components/tab-bar'
    import Echarts from '../../components/ec-canvas'
    import SetForm from '../../components/set-form'
    import downpdf from '../../mixin/downpdf'

    export default {
        name: "Home",
        data() {
            return {
                setShow: false,
                range: 30,
                rangeList: {
                    active: 'pxts',
                    list: {
                        pxts: {
                            value: 30,
                            name: '培训效率提升',
                            icon: 'icon-tisheng1',
                            label: '使用SQS解决方案后培训效率提升（%）',
                        },
                        shjl: {
                            value: 30,
                            name: '工件损坏几率',
                            icon: 'icon-tongji',
                            label: '培训操作不当造成工件损坏几率（%）',
                        },
                        shjs: {
                            value: 60,
                            name: '工件损坏减少',
                            icon: 'icon-jianshaoshunxuliuzhuanzhedian',
                            label: '使用SQS解决方案后工件损坏减少（%）',
                        },
                        pxtgl: {
                            value: 60,
                            name: '培训通过率',
                            icon: 'icon-tongguoshuai',
                            label: '单次培训通过率（%）',
                        },
                        tglts: {
                            value: 80,
                            name: '通过率提升',
                            icon: 'icon-tongji1',
                            label: '使用SQS解决方案后单次培训通过率提升到（%）',
                        },
                    }
                },
                set: {
                    pxjbsj: {
                        name: '培训基本数据',
                        type: 'section-title'
                    },
                    pjpxTime: {
                        name: '平均培训时间（小时）',
                        value: 2,
                        type: 'input'
                    },
                    dcpxgjMoeny: {
                        name: '单次培训工件成本（元）',
                        value: 50,
                        type: 'input'
                    },
                    mrpxzscTime: {
                        name: '每日培训总时长（小时）',
                        value: 8,
                        type: 'input'
                    },
                    ngzrNumber: {
                        name: '年工作日',
                        value: 200,
                        type: 'input'
                    },
                    cxyggsMoney: {
                        name: '产线员工工时费（元/小时）',
                        value: 100,
                        type: 'input'
                    },
                    dcpxgjsNumber: {
                        name: '单次培训所需工件数量',
                        value: 3,
                        type: 'input'
                    },
                    cpcb: {
                        name: 'SQS产品成本',
                        type: 'section-title'
                    },
                    jjfaMoney: {
                        name: 'SQS产品解决方案（元）',
                        value: 150000,
                        type: 'input'
                    },
                    aztsMoney: {
                        name: '安装及调试成本（元）',
                        value: 2000,
                        type: 'input'
                    },
                },
            }
        },
        mixins: [downpdf],
        watch: {
            range: {
                handler(val) {
                    this.rangeList.list[this.rangeList.active].value = val
                },
                immediate: true
            }
        },
        computed: {
            // 培训提升
            pxts() {
                return Number(this.rangeList.list.pxts.value) / 100
            },
            // 损坏几率
            shjl() {
                return Number(this.rangeList.list.shjl.value) / 100
            },
            // 损坏减少
            shjs() {
                return Number(this.rangeList.list.shjs.value) / 100
            },
            // 培训通过率
            pxtgl() {
                return Number(this.rangeList.list.pxtgl.value) / 100
            },
            // 通过率提升
            tglts() {
                return Number(this.rangeList.list.tglts.value) / 100
            },
            // 每年培训总时长节约（小时）
            mnpxscTime() {
                return (this.set.mrpxzscTime.value * this.set.ngzrNumber.value * this.pxts).toFixed(0)
            },
            // 时间成本节约（元/年）
            sjcbjyMoney() {
                return (this.mnpxscTime * this.set.cxyggsMoney.value).toFixed(0)
            },
            // 每年减少工件损坏数量
            jsgjshNumber() {
                return (this.set.dcpxgjsNumber.value * (this.set.mrpxzscTime.value / this.set.pjpxTime.value) * this.set.ngzrNumber.value * this.shjl * this.shjs).toFixed(0)
            },
            // 工件损坏成本节约（元/年）
            gjshcbMoney() {
                return Number(this.jsgjshNumber * this.set.dcpxgjMoeny.value).toFixed(0)
            },
            // 每年减少重复培训次数
            jccfpxNumber() {
                return Number((this.set.mrpxzscTime.value / this.set.pjpxTime.value) * this.set.ngzrNumber.value * (this.tglts - this.pxtgl)).toFixed(0)
            },
            // 重复培训成本节约（元/年）
            cfpxcbMoney() {
                return Number(this.jccfpxNumber * (this.set.dcpxgjMoeny.value + (this.set.pjpxTime.value * this.set.cxyggsMoney.value))).toFixed(0)
            },
            // SQS解决方案总成本（元）
            jjfazcbMoney() {
                return Number(this.set.jjfaMoney.value + this.set.aztsMoney.value).toFixed(0)
            },
            // 年投资回报（元）
            ntzhbMoney() {
                return (Number(this.cfpxcbMoney) + Number(this.gjshcbMoney) + Number(this.sjcbjyMoney)).toFixed(0)
            },
            // 投资回报周期（月）
            tzhbzqTime() {
                return (Number(this.jjfazcbMoney) / (this.ntzhbMoney / 12)).toFixed(2)
            },
            // 平均投资回报（元/次）
            pjtzhbMoney() {
                const a = Number(this.ntzhbMoney)
                const b = Number(this.set.ngzrNumber.value)
                const c = Number(this.set.mrpxzscTime.value)
                const d = Number(this.set.pjpxTime.value)
                return (a / (b * (c / d))).toFixed(2)
            },
        },
        components: {TabBar, Echarts, SetForm,},
        created() {
        },
        methods: {
            handlerToggleSet() {
                this.setShow = !this.setShow
            },
            handlerTab(item, key) {
                this.rangeList.active = key
                this.range = item.value
            },
            handlerOk(data) {
                this.set = data
            }
        },
    }
</script>

<style lang="scss">

    .chart-wrap {
        background-color: #f7f8fb;

        .right-table-wrap {

        }
    }
</style>
